import axios from "axios";
import { API_BASE as SBIN_API_BASE } from "./base";

const API = SBIN_API_BASE;

const authHeaders = (token) => {
  const authToken = token || null;
  return authToken
    ? {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json",
      }
    : { "Content-Type": "application/json" };
};

export async function getBillingSummary(token) {
  const res = await axios.get(`${API}/billing/summary`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function getBillingTransactions(token, { cursor, limit } = {}) {
  const params = {};
  if (cursor) params.cursor = cursor;
  if (limit) params.limit = limit;
  const res = await axios.get(`${API}/billing/transactions`, {
    params,
    headers: authHeaders(token),
  });
  return res.data;
}

export async function createBillingSetupIntent(token, payload = {}) {
  const res = await axios.post(`${API}/billing/setup-intent`, payload, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function setDefaultPaymentMethod(
  token,
  { payment_method_id, billing_details } = {}
) {
  const res = await axios.post(
    `${API}/billing/set-default-payment-method`,
    { payment_method_id, billing_details },
    {
      headers: authHeaders(token),
    }
  );
  return res.data;
}

export async function getBillingStatement(token, { from, to }) {
  const res = await axios.get(`${API}/billing/statement`, {
    params: { from, to },
    headers: authHeaders(token),
  });
  return res.data;
}

export async function syncBillingSeats(token) {
  const res = await axios.post(
    `${API}/billing/sync-seats`,
    {},
    {
      headers: authHeaders(token),
    }
  );
  return res.data;
}

export async function updateBillingTaxAddon(token, tax_addon_code = null) {
  const res = await axios.post(
    `${API}/billing/tax-addon`,
    { tax_addon_code },
    {
      headers: authHeaders(token),
    }
  );
  return res.data;
}

export async function applyBillingDiscountCode(token, code) {
  const res = await axios.post(
    `${API}/billing/discount-code`,
    { code },
    {
      headers: authHeaders(token),
    }
  );
  return res.data;
}

export async function removeBillingDiscountCode(token) {
  const res = await axios.delete(`${API}/billing/discount-code`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function cancelBillingSubscription(token) {
  const res = await axios.post(
    `${API}/billing/cancel-subscription`,
    {},
    {
      headers: authHeaders(token),
    }
  );
  return res.data;
}

export async function reactivateBillingSubscription(token) {
  const res = await axios.post(
    `${API}/billing/reactivate-subscription`,
    {},
    {
      headers: authHeaders(token),
    }
  );
  return res.data;
}
